module.exports = {
  GET_MRD_CONTACTS_REQUEST: 'GET_MRD_CONTACTS_REQUEST',
  GET_MRD_CONTACTS_SUCCESS: 'GET_MRD_CONTACTS_SUCCESS',
  GET_MRD_CONTACTS_FAILURE: 'GET_MRD_CONTACTS_FAILURE',
  ASSOCIATE_CONTACTS_REQUEST: 'ASSOCIATE_CONTACTS_REQUEST',
  ASSOCIATE_CONTACTS_SUCCESS: 'ASSOCIATE_CONTACTS_SUCCESS',
  ASSOCIATE_CONTACTS_FAILURE: 'ASSOCIATE_CONTACTS_FAILURE',
};
